import template from './worker.html';
import controller from './worker.controller';

let workerComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default workerComponent;
